import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ENTITIES/ACCOUNT_ITEMS';

export const {action: insertItem} = createAction(`${domain}/INSERT_ITEM`, item => ({item}));

export const {success: fetchAllSuccess} = createAction(`${domain}/FETCH_ALL`, () => ({}));

export const {
    action: fetchBillPayerBalance,
    success: fetchBillPayerBalanceSuccess,
    failed: fetchBillPayerBalanceFailed,
} = createAction(
    `${domain}/FETCH_BILL_PAYER_BALANCE`,
    (institutionId, billPayerId, filterCreditedInvoices, limit, expectedIds, unexpectedIds) => {
        return {
            institutionId,
            billPayerId,
            filterCreditedInvoices,
            limit,
            expectedIds,
            unexpectedIds,
        };
    },
);

export const {success: fetchPaymentsForTargetSuccess} = createAction(`${domain}/FETCH_PAYMENTS_FOR_TARGET`, () => ({}));

export const {success: fetchInvoicesForTargetSuccess} = createAction(`${domain}/FETCH_INVOICES_FOR_TARGET`, () => ({}));

export const {
    action: createInvoice,
    success: createInvoiceSuccess,
    failed: createInvoiceFailed,
    aborted: createInvoiceAborted,
} = createAction(`${domain}/CREATE_INVOICE`, (institutionId, billPayerId, invoice, currentMonths) => ({
    institutionId,
    billPayerId,
    invoice,
    currentMonths,
}));

export const {
    action: createInvoiceWithGraphQL,
    success: createInvoiceWithGraphQLSuccess,
    failed: createInvoiceWithGraphQLFailed,
    aborted: createInvoiceWithGraphQLAborted,
} = createAction(
    `${domain}/CREATE_INVOICE_WITH_GRAPH_QL`,
    (institutionId, billPayerId, invoiceData, currentMonths) => ({
        institutionId,
        billPayerId,
        invoiceData,
        currentMonths,
    }),
);

export const {
    action: previewInvoice,
    success: previewInvoiceSuccess,
    failed: previewInvoiceFailed,
} = createAction(`${domain}/PREVIEW_INVOICE`, (institutionId, billPayerId, invoice, currentMonths) => ({
    institutionId,
    billPayerId,
    invoice,
    currentMonths,
}));

export const {
    action: createPayment,
    success: createPaymentSuccess,
    failed: createPaymentFailed,
} = createAction(`${domain}/CREATE_PAYMENT`, (institutionId, billPayerId, payment) => ({
    institutionId,
    billPayerId,
    payment,
}));

export const {
    action: updatePayment,
    success: updatePaymentSuccess,
    failed: updatePaymentFailed,
} = createAction(`${domain}/UPDATE_PAYMENT`, (institutionId, billPayerId, payment, oldPayment) => ({
    institutionId,
    billPayerId,
    payment,
    oldPayment,
}));

export const {
    action: deletePayment,
    success: deletePaymentSuccess,
    failed: deletePaymentFailed,
    aborted: deletePaymentAborted,
} = createAction(`${domain}/DELETE_PAYMENT`, (institutionId, billPayerId, payment) => ({
    institutionId,
    billPayerId,
    payment,
}));
